/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../types.generated";
export type GetAllHackersQueryVariables = Types.Exact<{
  skip: Types.Scalars["Int"];
  take: Types.Scalars["Int"];
  stages: Array<Types.Scalars["String"]> | Types.Scalars["String"];
  schools?: Types.Maybe<
    Array<Types.Scalars["String"]> | Types.Scalars["String"]
  >;
  programs?: Types.Maybe<
    Array<Types.Scalars["String"]> | Types.Scalars["String"]
  >;
  graduatingYearMin?: Types.Maybe<Types.Scalars["Int"]>;
  graduatingYearMax?: Types.Maybe<Types.Scalars["Int"]>;
  query?: Types.Maybe<Types.Scalars["String"]>;
  claimIds?: Types.Maybe<Array<Types.Scalars["Int"]> | Types.Scalars["Int"]>;
  interested?: Types.Maybe<Types.Scalars["Boolean"]>;
}>;

export type GetAllHackersQuery = {
  getSponsorRecruitmentCandidates: Pick<
    Types.SponsorRecruitmentCandidatesPage,
    "totalCount"
  > & {
    candidates: Array<
      Pick<
        Types.SponsorRecruitmentCandidate,
        | "id"
        | "name"
        | "email"
        | "links"
        | "school"
        | "program"
        | "level_of_study"
        | "graduating_year"
        | "sponsor_interests"
        | "application_stage"
      > & {
        resume?: Types.Maybe<
          Pick<
            Types.FileFieldAnswerType,
            "id" | "mime_type" | "uri" | "name" | "expiry" | "is_valid"
          >
        >;
      }
    >;
  };
};

export const GetAllHackersDocument = gql`
  query GetAllHackers(
    $skip: Int!
    $take: Int!
    $stages: [String!]!
    $schools: [String!]
    $programs: [String!]
    $graduatingYearMin: Int
    $graduatingYearMax: Int
    $query: String
    $claimIds: [Int!]
    $interested: Boolean
  ) {
    getSponsorRecruitmentCandidates(
      skip: $skip
      take: $take
      stages: $stages
      schools: $schools
      programs: $programs
      graduating_year_min: $graduatingYearMin
      graduating_year_max: $graduatingYearMax
      query: $query
      claim_ids: $claimIds
      interested: $interested
    ) {
      totalCount
      candidates {
        id
        name
        email
        links
        school
        program
        level_of_study
        graduating_year
        sponsor_interests
        application_stage
        resume {
          id
          mime_type
          uri
          name
          expiry
          is_valid
        }
      }
    }
  }
`;

/**
 * __useGetAllHackersQuery__
 *
 * To run a query within a React component, call `useGetAllHackersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllHackersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllHackersQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      stages: // value for 'stages'
 *      schools: // value for 'schools'
 *      programs: // value for 'programs'
 *      graduatingYearMin: // value for 'graduatingYearMin'
 *      graduatingYearMax: // value for 'graduatingYearMax'
 *      query: // value for 'query'
 *      claimIds: // value for 'claimIds'
 *      interested: // value for 'interested'
 *   },
 * });
 */
export function useGetAllHackersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAllHackersQuery,
    GetAllHackersQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetAllHackersQuery,
    GetAllHackersQueryVariables
  >(GetAllHackersDocument, baseOptions);
}
export function useGetAllHackersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllHackersQuery,
    GetAllHackersQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetAllHackersQuery,
    GetAllHackersQueryVariables
  >(GetAllHackersDocument, baseOptions);
}
export type GetAllHackersQueryHookResult = ReturnType<
  typeof useGetAllHackersQuery
>;
export type GetAllHackersLazyQueryHookResult = ReturnType<
  typeof useGetAllHackersLazyQuery
>;
export type GetAllHackersQueryResult = ApolloReactCommon.QueryResult<
  GetAllHackersQuery,
  GetAllHackersQueryVariables
>;
